/* ============================================================
   COLOCA LA RESENA DEBAJO DE LOS ACORDEONES DE LA FICHA
   (2 sep 2026, pedido suyo con la referencia de gudslip.com)

   La tarjeta la genera `snippets/pn-cita-ficha.liquid` dentro de un
   <template>. Aqui solo se clona y se pega detras de
   `.producto-nazalea__acordeones`, que es el bloque que agrupa los cuatro
   desplegables (Detalles, Guia de tallas, Tejido y cuidados, Envios).

   ⚠️ SE HACE POR JS Y NO EN LA SECCION porque `sections/producto-nazalea.liquid`
   es enorme y reescribirlo entero por una tarjeta es pedir un accidente. Es
   el mismo patron que ya usa `pn-fichaorden.js`, que mueve la barra de
   confianza dentro del formulario.

   ⚠️ SI NO HAY RESENA, EL <template> NO EXISTE y este script no hace nada:
   el snippet no emite tarjeta cuando la prenda no tiene `custom.resenas`.

   ⚠️ LA MARCA `data-pn-cita` EVITA DUPLICADOS. La seccion se vuelve a pintar
   al cambiar de variante y sin la marca se irian apilando tarjetas.
   ============================================================ */
(function () {
  'use strict';

  function colocar() {
    var plantilla = document.getElementById('pn-cita-plantilla');
    if (!plantilla) { return; }

    var cajas = document.querySelectorAll('.producto-nazalea__acordeones');
    if (!cajas.length) { return; }

    Array.prototype.forEach.call(cajas, function (caja) {
      if (caja.getAttribute('data-pn-cita') === '1') { return; }
      caja.setAttribute('data-pn-cita', '1');
      var copia = plantilla.content.cloneNode(true);
      if (caja.parentNode) {
        caja.parentNode.insertBefore(copia, caja.nextSibling);
      }
    });
  }

  function vigilar() {
    var raiz = document.querySelector('[data-producto-nazalea]');
    if (!raiz || raiz.dataset.pnCitaVigilada === '1' || !window.MutationObserver) { return; }
    raiz.dataset.pnCitaVigilada = '1';
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(colocar, 120);
    }).observe(raiz, { childList: true, subtree: true });
  }

  function iniciar() { colocar(); vigilar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
  setTimeout(iniciar, 900);
  setTimeout(iniciar, 2200);
})();
